import { Trash2 } from "lucide-react";
import { SlateButton } from "components/Note/extras/extras";
import { ReactNode } from "react";
import { Transforms } from "slate";
import {
  ReactEditor,
  useFocused,
  useSelected,
  useSlateStatic,
} from "slate-react";

interface ImageNoteProps {
  attributes: any;
  children: ReactNode;
  element: any;
}

export default function ImageNote(props: ImageNoteProps) {
  const { attributes, children, element } = props;
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);

  const selected = useSelected();
  const focused = useFocused();
  return (
    <div {...attributes}>
      {children}
      <div
        contentEditable={false}
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="relative">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            alt=""
            src={element.url}
            style={{
              display: "block",
              maxWidth: "100%",
              maxHeight: "20em",
              boxShadow: selected && focused ? "0 0 0 1px #B4D5FF" : "none",
              borderRadius: "10px !important",
            }}
          />
          <SlateButton
            active
            onClick={() => Transforms.removeNodes(editor, { at: path })}
            style={{
              display: `${selected && focused ? "block" : "none"}`,
              position: "absolute",
              top: "0.5em",
              left: "0.5em",
              backgroundColor: "black",
              borderRadius: "100%",
              width: "25px",
              height: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Trash2 className="h-4 w-4" />
          </SlateButton>
        </div>
      </div>
    </div>
  );
}
